export default __webpack_public_path__ + "static/stakingrewards-2745e1d714849d8362e269e380d0e42e.svg";